// src/components/DashboardLayout.js
import React from "react";
import { Outlet } from "react-router-dom";
import AppHeader from "./Header";
import "./DashboardLayout.css";
import { useAuth } from "../auth/AuthContext";
import { buildMenuItems } from "../nav/menuConfig";
import MenuList from "./MenuList";

export default function DashboardLayout() {
  const { role } = useAuth();

  const userType = role ?? "patient";
  
  const items = buildMenuItems(userType);

  return (
    <div className="dashboard-layout">
      <AppHeader />

      <div className="main-layout">
        <aside
          className="sidebar"
          style={{ width: "300px", padding: "1rem", background: "#f8f8f8" }}
        >
          {/* サイドバー上部（戻るリンクは MenuList 内に含まれる） */}
          <MenuList items={items} />
        </aside>

        <main className="main-content" style={{ flex: 1, paddingTop: "1rem", paddingBottom: "2rem" }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
